import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateMedicineGroupService } from 'src/app/shared/services/API/pharmacy/template-medicine-grouop.service';

@Component({
  selector: 'app-template-group-delete-modal',
  templateUrl: './template-group-delete-modal.component.html',
  styleUrls: ['./template-group-delete-modal.component.css']
})
export class TemplateGroupDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<TemplateGroupDeleteModalComponent>,
    private templateMedicineGroupService: TemplateMedicineGroupService,
    private alertService: AlertService
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteMedicineGroup: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.templateMedicineGroupService.deleteTemplateMedicineGroup(this.data.idMedicineGroup).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Grupo de medicamento excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteMedicineGroup: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteMedicineGroup: false}); 
  }
}
